import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";
import Axios from "axios";
import DashboardAdmin from "../DashboardAdmin";
import useUserState from "../../hooks/useUserState";
import useBDocTranslator from "../../hooks/useBDocTranslator";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    backgroundColor: "#fff",
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
  tableHeader: {
    backgroundColor: fade(theme.palette.primary.main, 0.05),
    "& .MuiTableCell-head": {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
}));

export default function AssistantUsageReport() {
  const classes = useStyles();
  const userState = useUserState();
  const { t } = useBDocTranslator();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const jwt = userState[0]?.jwt;
    Axios.get(`${process.env.REACT_APP_API_URL_BASE}/assistant/usage`, {
      headers: { Authorization: `Bearer ${jwt}` },
    })
      .then((res) => setRows(res.data.data || []))
      .catch((error) => {
        console.error("Error fetching assistant usage:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardAdmin>
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography variant="h4" color="textSecondary">
            {t("Virtual Assistant Usage Report")}
          </Typography>
        </div>

        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow className={classes.tableHeader}>
                <TableCell>{t("Proveedor ID")}</TableCell>
                <TableCell>{t("Tokens de entrada")}</TableCell>
                <TableCell>{t("Tokens de salida")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.provider_id} hover>
                  <TableCell>{r.provider_id}</TableCell>
                  <TableCell>{r.input_tokens_used}</TableCell>
                  <TableCell>{r.output_tokens_used}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </DashboardAdmin>
  );
}
